import store from "../store/index";

const replace = (value, token, replacement) =>
  String(value || "").replace(token, replacement);

export default {
  getTenantName() {
    return window.location.hostname.split(".")[0];
  },
  getApiBaseUrl() {
    return replace(
      process.env.VUE_APP_API,
      "{{domain}}",
      window.location.hostname
    );
  },
  getAppMediaUrl() {
    return replace(
      process.env.VUE_APP_MEDIA_URL,
      "{{tenant}}",
      this.getTenantName()
    );
  },
  getAppMediaApi() {
    return replace(
      process.env.VUE_APP_MEDIA_API,
      "{{tenant}}",
      this.getTenantName()
    );
  },
  getAppFilesUrl() {
    return replace(
      process.env.VUE_APP_FILES,
      "{{domain}}",
      window.location.hostname
    );
  },
  getTenantUrl() {
    return store.state.webshopBaseUrl;
  },
};
